var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSucessicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "80px",
    height: "80px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 80,
    y1: 7.105427357601002e-14,
    x2: 0,
    y2: 87.4814814814814,
    id: "LinearGradient49"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "Stop50",
    stopColor: "#a1e8af",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "Stop51",
    stopColor: "#32936f",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -674 -144 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80 40  C 80 62.39999999999998  62.39999999999998 80  40 80  C 17.600000000000023 80  0 62.39999999999998  0 40  C 0 17.600000000000023  17.600000000000023 0  40 0  C 62.39999999999998 0  80 17.600000000000023  80 40  Z M 30.53749999999991 57.15395373078081  C 31.190653246785587 57.15395373078081  31.817010159131087 56.89427958835893  32.27857142857147 56.43214285714282  L 63.50714285714275 25.20357142857131  C 64.46717588002457 24.24276354826219  64.46717588002457 22.685807880309255  63.50714285714275 21.72499999999991  C 63.0455815877026 21.26286326878369  62.41922467535687 21.003189126361974  61.76607142857142 21.003189126361974  C 61.11291818178597 21.003189126361974  60.486561269440244 21.26286326878369  60.02500000000009 21.72499999999991  L 30.539285714285597 51.21071428571429  L 19.203571428571422 39.874999999999886  C 18.74181057572582 39.4132391471544  18.115528460667292 39.15382460122521  17.46250000000009 39.15382460122521  C 16.102638626937505 39.15382460122521  15.000253172654084 40.256210055508745  15.000253172654084 41.61607142857133  C 15.000253172654084 42.269099889238646  15.259667718582932 42.895382004297176  15.721428571428532 43.35714285714289  L 28.796428571428578 56.43214285714282  C 29.25798984086896 56.89427958835893  29.88434675321446 57.15395373078081  30.53749999999991 57.15395373078081  Z ",
    fillRule: "nonzero",
    fill: "url(#LinearGradient49)",
    stroke: "none",
    transform: "matrix(1 0 0 1 674 144 )"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessicon);
export default __webpack_public_path__ + "static/media/sucessicon.625f7b6f175c2f68ceb41d9dc5714021.svg";
export { ForwardRef as ReactComponent };